<template>
  <div class="fb-wrapper div-filters">
    <div class="fb-container">
      <!-- Search row -->
      <div class="fb-search-row" v-if="currentUser.type !== 'Sourcing'">
        <div class="fb-search-input-wrap">
          <v-select v-if="config.filters.elements.search.dropdowns" v-model="config.filters.elements.search.dropdowns.value" label="name" :options="config.filters.elements.search.dropdowns.values" class="fb-search-dropdown"></v-select>
          <i class="material-icons fb-search-icon">search</i>
          <input
            :placeholder="config.filters.elements.search.dropdowns ? config.filters.elements.search.dropdowns.value.name || '...' : config.filters.elements.search.options.hint"
            @keyup.enter="trigger"
            v-model="searchText"
            type="search"
            autofill="off"
            class="fb-search-input"
          />
          <button @click="search" ref="sendReply" class="fb-search-btn">
            <i class="material-icons" style="font-size:20px">search</i>
          </button>
        </div>
        <button v-if="currentUser.type !='CallenterManager'" @click="showMore = !showMore" class="fb-toggle-btn" :class="{ 'fb-toggle-active': showMore }">
          <i class="material-icons">{{ showMore ? 'keyboard_arrow_up' : 'tune' }}</i>
        </button>
      </div>

      <!-- Expandable filters -->
      <div v-if="showMore" class="fb-filters-panel">
        <div class="fb-filters-grid">
          <template v-for="(item, index) in config.filters.elements.champs">
          <div :key="index" v-if="isShown(item) && getShow(item.key) && item.key != 'from' && item.key != 'to'">
            <div class="fb-filter-item">
              <label class="fb-filter-label">{{ item.label }}</label>
              <!-- Select -->
              <div v-if="item.type == 'select' && getShow(item.key)">
                <div v-if="item.name">
                  <v-select v-if="item.key=='product'" @search="getProducts($event)" :label="item.name" v-model="filter[item.key]" :options="products" class="fb-filter-select"></v-select>
                  <v-select v-else :class="config.name==='orders' && item.key==='status_pending' && (!checkstatusorder || (checkstatusorder && checkstatusorder!='Pending' && checkstatusorder!='Unreached'))?'disabled':''" @input="CheckSellerProducts" @search="getUsers($event,item.key)" :label="item.name" v-model="filter[item.key]" :options="item.values" class="fb-filter-select"></v-select>
                </div>
                <div v-else>
                  <v-select v-model="filter[item.key]" :options="item.values" class="fb-filter-select"></v-select>
                </div>
              </div>
              <!-- Number -->
              <div v-else-if="item.type == 'number'">
                <input :min="item.min" :step="item.step" v-model="filter[item.key]" :type="item.type" :name="item.key" :id="item.key" class="fb-filter-number" />
              </div>
              <!-- Range -->
              <div v-else-if="item.type == 'range_numbers'" class="fb-range-wrap">
                <MultiRangeSlider :min="0" :max="12" baseClassName="multi-range-slider-bar-only" :minValue="(item.value && item.value.min) || 0" :maxValue="(item.value && item.value.max) || 12" @input="UpdateValues" />
              </div>
              <!-- Other (text, date, date_range) -->
              <div v-else>
                <input v-if="item.type != 'date_range'" v-model="filter[item.key]" :type="item.type" :name="item.key" :id="item.key" class="fb-filter-number" />
                <date-picker v-else :placeholder="item.placeholder" @change="DateRange" format="YYYY-MM-DD" class="w-full-imp" v-model="filter[item.key]" range></date-picker>
              </div>
            </div>
          </div>
          </template>
        </div>

        <!-- Date from/to -->
        <div v-if="config.filters.hasFilterdate && currentUser.type != 'Accountant'" class="fb-filters-grid" style="margin-bottom:14px">
          <div v-for="(item, index) in config.filters.elements.champs" :key="'d'+index" v-show="isShown(item)">
            <div v-if="getShow(item.key) && (item.key == 'from' || item.key == 'to')" class="fb-filter-item">
              <label class="fb-filter-label">{{ item.label }}</label>
              <input v-model="filter[item.key]" :type="item.type" :name="item.key" :id="item.key" class="fb-filter-number" />
            </div>
          </div>
        </div>

        <!-- Actions -->
        <div class="fb-actions">
          <button @click="ClearFilters" class="fb-btn-reset" :class="loading ? 'noselect' : ''">
            <i class="material-icons" style="font-size:16px;margin-right:4px">refresh</i> Reset
          </button>
          <button v-if="config.filters.elements.champs.length>0" @click="filtrer_saerch" class="fb-btn-filter" :class="loading ? 'noselect' : ''">
            <i class="material-icons" style="font-size:16px;margin-right:4px">filter_list</i> Filter
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from "vue-clickaway";
export default {
  mixins: [clickaway],
  props: {
    config: { required: true, type: Object},
    currentUser: { type: Object },
    idWharhouse: { type: Object },
    productsarray:{ type: Array },
    name:{type:String},
    loading:{required:false},
  },
  data() {
    return {
      showMore: false,
      searchText: "",
      filter: {},
      products:this.productsarray,
      sellerSelected:null,
      checkstatusorder:null,
      fullPage: false,
      open:false
    };
  },
  watch: {
      'productsarray': async function(oldVal, newVal) {
        this.products=this.productsarray;
      }
  },
  async mounted() {
    this.config.filters.elements.champs.forEach((filter) => {
      if (filter.value)
        this.$set(this.filter, filter.key, filter.value, filter.values);
    });

    if(this.currentUser && this.currentUser.type === "Sourcing") this.showMore = true;
    
   
  },
  methods: {
    UpdateValues(e) {
      this.barMinValue = e.minValue;
      this.barMaxValue = e.maxValue;
      if(!this.filter.range_numbers) this.filter.range_numbers={};
     // console.log('filter 11----',this.filter)
      this.filter.range_numbers.min=e.minValue;
      this.filter.range_numbers.max=e.maxValue;
    //  console.log('UpdateValues filter----',this.filter)
    },
  DateRange(data){
    //console.log('data date-------------------', data.map( el => this.$moment(el).format('yyyy-MM-DD')))
   // console.log('data date-------------------', data)
    //console.log('data date 00-------------------',this.$moment(data[0]).format('yyyy-MM-DD'))
   // console.log('Range_updatedAt------',this.filter['Range_updatedAt'])
   // console.log('Range_date------',this.filter['Range_date'])
   
  },
  away() {
      this.open = false;
    },
   getUsers: _.debounce(async function(name,type) {
    //  console.log('event______________',name)
     //console.log('warhouset______________',type)
        if(type=="seller" || type=="courier" || type=="zone"){
          await this.$store.dispatch('wharhouse/searchUser',{type: type,warhouse:this.idWharhouse._id,search:name}).then((res) => {
            console.log('res-----------',res)
            const objIndex = this.config.filters.elements.champs.findIndex((obj => obj.key == type));
            this.config.filters.elements.champs[objIndex].values = res
          })
        }
   }, 500), 
   getProducts: _.debounce(async function(name) {
     console.log('event______________',name)
     const filterParams=this.$f.QueryStringToobject();
      console.log('filterParams______________',filterParams)
     const filter={seller: this.sellerSelected,warhouse:this.idWharhouse._id,search:name,notPopulate:true};
     if(filterParams.seller) filter.seller=filterParams.seller;
        await this.$store.dispatch('wharhouse/searchProducts',filter).then((res) => {
            this.products = res;
        })
   }, 500), 
   async CheckSellerProducts(seller){
    console.log('seller----------',seller)
     if(this.name=="orders" && seller && seller.name && seller.env){
         this.checkstatusorder=seller.name;
         console.log('checkstatusorder-----',this.checkstatusorder)
      }
      if((this.name=="shippings" || this.name=="orders") && seller && seller.warehouses && seller.type){
        this.products = [];
        this.sellerSelected=seller._id;
        const res = await this.$server.search("products", { seller: seller._id,limit:10,notPopulate:true });
        if (res && res.content.results) {
          this.products = res.content.results;
        } else {this.products = [];this.sellerSelected=null}
      }
    },
    trigger() {
      this.$refs.sendReply.click();
    },
    //  getShow(champ){
    //    if((champ==="seller" || champ==="courier" || champ==="zone") && this.currentUser.type ==="Seller") return false
    //    else if((champ==="seller" || champ==="product") && this.currentUser.type ==="Accountant") return false
    //    else return true
    //  },
     getShow(champ) {
        const rules = {
          Seller: ['seller', 'courier', 'zone','phone'],
          Accountant: ['seller', 'product'],
          Sourcing: ['seller', 'courier', 'zone']
        }

        const forbidden = rules[this.currentUser.type] || []
        return !forbidden.includes(champ)
      },

      reset: function (val) {
          this.$emit('reset',val);
      },
      filtrer: function (val) {
          this.$emit('filtrer',val);
      },
      search: function () {
         if(!this.loading){
          if(!this.searchText){
            alert("Value empty !!", "warning");
            return false;
          }
          let dataFilterVlaue=null;
          if(this.config.filters.elements.search.dropdowns){
             if(!this.config.filters.elements.search.dropdowns.value){
                alert("Filter value required !!", "warning");
                return false;
             }else dataFilterVlaue=this.config.filters.elements.search.dropdowns.value;
              
          }
          console.log('dataFilterVlaue value ---',dataFilterVlaue)
          this.$emit('search',this.searchText,dataFilterVlaue);
         } 
      },
      isShown(item) {
      let shown =
        !item.show ||
        (item.show && this.filter[item.show.key] == item.show.equal);
      if (!shown) this.$set(this.filter, item.key, null);
      return shown;
    },
    searc() {
      //console.log(this.articleType);
    },

    /*********************************************************************************** */
     async filtrer_saerch() {
      this.filtrer(this.filter);
    },
    async ClearFilters() {
      console.log('oook')
      this.reset(this.filter);
      this.filter = {};
    },
  },
};
</script>

<style>
/* ===== DivFilter Full Styles ===== */
.div-filters .fb-wrapper,
.div-filters.fb-wrapper {
  padding: 12px 0 0;
  margin-bottom: 15px;
}
.div-filters .fb-container {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 14px 16px;
  transition: box-shadow 0.2s;
}
.div-filters .fb-container:focus-within {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
}

/* Search row */
.div-filters .fb-search-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.div-filters .fb-search-input-wrap {
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
}
.div-filters .fb-search-icon {
  position: absolute;
  left: 12px;
  font-size: 20px;
  color: #94a3b8;
  pointer-events: none;
  z-index: 1;
}
.div-filters .fb-search-input {
  width: 100%;
  height: 40px;
  padding: 0 14px 0 40px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 13px;
  color: #1e293b;
  background: #f8fafc;
  outline: none;
  transition: all 0.2s;
}
.div-filters .fb-search-input:focus {
  border-color: #4285f4;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(66, 133, 244, 0.1);
}
.div-filters .fb-search-input::placeholder {
  color: #94a3b8;
}

/* Search dropdown */
.div-filters .fb-search-dropdown {
  min-width: 130px;
  height: 40px;
  border: 1px solid #e2e8f0;
  border-radius: 10px 0 0 10px;
  background: #f1f5f9;
  font-size: 13px;
  flex-shrink: 0;
}
.div-filters .fb-search-dropdown .vs__dropdown-toggle {
  height: 38px;
  min-height: 38px;
  border: none;
}
.div-filters .fb-search-dropdown ~ .fb-search-icon {
  display: none;
}
.div-filters .fb-search-dropdown ~ .fb-search-input {
  border-radius: 0 !important;
  padding-left: 14px !important;
}

/* Search button */
.div-filters .fb-search-btn {
  width: 42px;
  min-width: 42px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0 10px 10px 0;
  border: 1px solid #e2e8f0;
  border-left: none;
  background: #4285f4;
  color: #ffffff;
  cursor: pointer;
  transition: all 0.2s;
  outline: none;
}
.div-filters .fb-search-btn:hover {
  background: #3367d6;
}

/* Toggle button */
.div-filters .fb-toggle-btn {
  width: 40px;
  height: 40px;
  min-width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s;
  outline: none;
}
.div-filters .fb-toggle-btn:hover {
  background: #e2e8f0;
  color: #1e293b;
}
.div-filters .fb-toggle-btn.fb-toggle-active {
  background: #4285f4;
  border-color: #4285f4;
  color: #ffffff;
}

/* Filters panel */
.div-filters .fb-filters-panel {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px dashed #e2e8f0;
}

/* Filters grid */
.div-filters .fb-filters-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  margin-bottom: 14px;
}
.div-filters .fb-filters-grid > div {
  min-width: 180px;
  max-width: 220px;
  flex: 1 1 180px;
}
.div-filters .fb-filter-item {
  display: flex;
  flex-direction: column;
}
.div-filters .fb-filter-label {
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}
.div-filters .fb-filter-select,
.div-filters .fb-filter-number {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 13px;
  color: #1e293b;
  background: #f8fafc;
  outline: none;
  transition: all 0.2s;
  appearance: auto;
}
.div-filters .fb-filter-select:focus,
.div-filters .fb-filter-number:focus {
  border-color: #4285f4;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(66, 133, 244, 0.1);
}
.div-filters .fb-filter-item > div {
  width: 100%;
}
.div-filters .fb-filter-item > div > div,
.div-filters .fb-filter-item > div > span {
  width: 100%;
  border: none !important;
  padding: 0 !important;
  height: auto !important;
}
.div-filters .fb-filter-item .v-select {
  width: 100% !important;
  font-size: 13px;
}
.div-filters .fb-filter-item input,
.div-filters .fb-filter-item select,
.div-filters .fb-filter-item .mx-datepicker {
  width: 100%;
  height: 38px;
  padding: 0 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 13px;
  color: #1e293b;
  background: #f8fafc;
  outline: none;
  box-sizing: border-box;
}
.div-filters .fb-filter-item .mx-input {
  height: 34px !important;
  border: none !important;
  font-size: 13px !important;
}
.div-filters .fb-filter-item input:focus,
.div-filters .fb-filter-item select:focus {
  border-color: #4285f4;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(66, 133, 244, 0.1);
}
.div-filters .fb-filter-item .v-select {
  border: none !important;
  background: transparent !important;
  max-height: 38px !important;
  padding: 0 !important;
}
.div-filters .fb-filter-item .v-select .vs__dropdown-toggle {
  border: 1px solid #e2e8f0 !important;
  border-radius: 8px !important;
  background: #f8fafc !important;
  height: 38px !important;
  min-height: 38px !important;
  max-height: 38px !important;
  padding: 0 8px !important;
}
.div-filters .fb-filter-item .v-select .vs__selected-options {
  flex-wrap: nowrap !important;
  padding: 0 !important;
}
.div-filters .fb-filter-item .v-select .vs__search {
  padding: 0 !important;
  margin: 0 !important;
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}
.div-filters .fb-filters-grid {
  align-items: start;
}

/* Action buttons */
.div-filters .fb-actions {
  display: flex;
  justify-content: center;
  gap: 10px;
  padding-top: 4px;
}
.div-filters .fb-btn-reset {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 24px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #64748b;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  outline: none;
}
.div-filters .fb-btn-reset:hover {
  background: #f1f5f9;
  color: #1e293b;
}
.div-filters .fb-btn-filter {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 24px;
  border-radius: 8px;
  border: none;
  background: #4285f4;
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  outline: none;
}
.div-filters .fb-btn-filter:hover {
  background: #3367d6;
}

/* Range slider wrapper */
.div-filters .fb-range-wrap {
  height: 38px;
  display: flex;
  align-items: center;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  padding: 0 8px;
}

.div-filters .fb-range-wrap .multi-range-slider-bar-only {
   margin-top: 0;
}

.div-filters .multi-range-slider-bar-only {
  box-shadow: none !important;
  width: 100%;
  margin-top: 14px;
}

/* Date picker */
.div-filters .fb-filter-item .mx-datepicker {
  border: 1px solid #e2e8f0 !important;
  border-radius: 8px !important;
  background: #f8fafc !important;
  height: 38px !important;
}
.div-filters .fb-filter-item .mx-datepicker .mx-input {
  border: none !important;
  height: 36px !important;
  font-size: 13px !important;
  background: transparent !important;
  box-shadow: none !important;
}
.div-filters .fb-filter-item .w-full-imp {
  width: 100% !important;
}

/* Responsive */
@media (max-width: 640px) {
  .div-filters .fb-filters-grid {
    grid-template-columns: 1fr;
  }
  .div-filters .fb-actions {
    flex-direction: column;
  }
  .div-filters .fb-btn-reset,
  .div-filters .fb-btn-filter {
    width: 100%;
  }
}
</style>